export default function cleanURL(t) {
    return t?.toLowerCase().replace(/[^a-z0-9]+/g,'-');
}